import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import MiniWidgets from "./ChartComponet/MiniWidgets";
import WebsiteAnalytics from "./WebsitesAnalytics";
import BetaSalesAnalytics from "./BetaSalesAnalytics";
import ApplicationDownloader from "./ApplicationDownloader";
import AndroidDeviceData from "./AndroidDeviceData";
import AndroidOnlineDevices from "./AndroidOnlineDevices";
import GetLAtestBetaSubsciber from "./GetLAtestBetaSubsciber";
import LatestWebVisitors from "./LatestWebVisitors";
import PageSection from "../../components/Loader/loader";

import { useSelector, useDispatch } from "react-redux";
import { fetchMiniWidgetDataRequest } from "../../store/Dashboard/dashboardAction";

const Dashboard = () => {
    const dispatch = useDispatch();

    const { data: miniWidget, loading } = useSelector((state) => state.miniWidget);

    const [breadcrumbItems] = useState([
        { title: "Minimis", link: "/" },
        { title: "Dashboard", link: "#" },
    ]);

    const [reports, setReports] = useState([
        { icon: "ri-device-line", title: "Total Devices", value: "0", rate: "0%", desc: "From previous period" },
        { icon: "ri-android-line", title: "Android Devices", value: "0", rate: "0%", desc: "From previous period" },
        { icon: "ri-apple-line", title: "iOS Devices", value: "0", rate: "0%", desc: "From previous period" },
    ]);

    // Dispatch the action to fetch data
    useEffect(() => {
        dispatch(fetchMiniWidgetDataRequest());
    }, [dispatch]);

    useEffect(() => {
        if (miniWidget) {
            const { total, android, iOS } = miniWidget;

            setReports([
                { icon: "ri-device-line", title: "Total Devices", value: total || "0", rate: "N/A", desc: "Previous update" },
                { icon: "ri-android-line", title: "Android Devices", value: android || "0", rate: "N/A", desc: "Previous update" },
                { icon: "ri-apple-line", title: "iOS Devices", value: iOS || "0", rate: "N/A", desc: "Previous update" },
            ]);
        }
    }, [miniWidget]);

    return (
        <React.Fragment>
            <div className="page-content">
            <Container fluid>
            <Breadcrumbs title="Dashboard" breadcrumbItems={breadcrumbItems} />
            {/* Main Content Section with Loader */}
            <div style={{ position: "relative" }}>
                {loading && (
                    <div style={overlayStyle}>
                        <PageSection />
                    </div>
                )}

                <Row>
                    <Col xl={8}>
                        <Row>
                            <MiniWidgets reports={reports} />
                        </Row>
                        <WebsiteAnalytics />
                    </Col>
                    <Col xl={4}>
                        <BetaSalesAnalytics />
                        <ApplicationDownloader />
                    </Col>
                </Row>
                <Row>
                    <AndroidDeviceData />
                    <AndroidOnlineDevices />
                    <GetLAtestBetaSubsciber />
                </Row>
                <Row>
                    <LatestWebVisitors />
                </Row>
            </div>
        </Container>
            </div>
        </React.Fragment>
    );
};

const overlayStyle = {
    position: "absolute",
    paddingTop: "200px",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    zIndex: 999,
};

export default Dashboard;
